import React from 'react';
import styles from '../radiorbfm/radiorbfm.module.scss';
import { Users, Globe, Mic, Briefcase, MapPin, Radio } from 'lucide-react';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import FacebookIcon from '../../icons/facebookIcon.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';

const Radiorbfm: React.FC = () => {
    return (
        <div className={styles.radiorbfm}>
            <div className={styles.header}>
                <img
                    src={require("./src/logo.png")}
                    alt="Logo Rádio RB"
                    className={styles.logo}
                />
                <h1 className={styles.title}>Rádio RB</h1>
                <p className={styles.subtitle}>88.3fm</p>
            </div>

            <div className={styles.content}>
                <a href="https://player.srvstm.com/proxy/9472" className={styles.button}>
                    <Radio size={18} />
                    <span>Ouça Ao Vivo</span>
                </a>
                <a href="https://chat.whatsapp.com/E4Re6QaDF474SUD4gzlf4c?fbclid=PAZXh0bgNhZW0CMTEAAacOdIhI7hm95bEQuUkA0bfcyugze7kxHr5Y7ycFr-SlPbSN4PBN1sDdj4S3yQ_aem_Y-qV6CkO4O5lqMaylUBOnw" className={styles.button}>
                    <Users size={18} />
                    <span>RB NEWS - Grupo WhatsApp</span>
                </a>

                <a href="https://www.radiorbfm.com.br/" className={styles.button}>
                    <Globe size={18} />
                    <span>Site</span>
                </a>

                <a
                    href="https://wa.me/5517996018304?text=Olá!%20Quero%20participar%20do%20Estúdio%20Ao%20Vivo."
                    className={styles.button}
                >
                    <Mic size={18} />
                    <span>Estúdio Ao Vivo - Participação</span>
                </a>

                <a
                    href="https://wa.me/551733426344?text=Olá!%20Gostaria%20de%20informações%20comerciais/administrativas."
                    className={styles.button}
                >
                    <Briefcase size={18} />
                    <span>RB - Comercial/Administrativo</span>
                </a>


                <a href="https://www.instagram.com/radiorbfm?igsh=MWsya2I0YWYwZDJoNA==" className={styles.button}>
                    <InstagramIcon height="18px" color="#ffffff" />
                    <span>Instagram</span>
                </a>

                <a href="https://www.facebook.com/share/17AU3AHpkn/?mibextid=wwXIfr" className={styles.button}>
                    <FacebookIcon height="20px" color="#ffffff" />
                    <span>Facebook</span>
                </a>

                <a href="https://www.tiktok.com/@radiorb88.3?_t=ZM-901QMUVUSSK&_r=1" className={styles.button}>
                    <TiktokIcon height="16px" color="#ffffff" />
                    <span>TikTok</span>
                </a>

                <a href="https://maps.app.goo.gl/km2fxTg97ZtH33Ky7?g_st=iwb" className={styles.button}>
                    <MapPin size={18} />
                    <span>Localização</span>
                </a>
            </div>

            <div className={styles.footer}>
                <p>
                    A Rádio BFM há 78 anos informando, divertindo e premiando Bebedouro e Região.
                </p>
            </div>
        </div>
    );
};

export default Radiorbfm;
